export default __webpack_public_path__ + "static/media/sticker-L.1cc80504.png";